var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "ml-2 ml-md-5 ml-sm-2 mr-4 pb-3" },
    [
      _vm.items.length === 0 ? _c("custom-result-not-found") : _vm._e(),
      _c(
        "time-line",
        { staticClass: "mt-4" },
        _vm._l(_vm.items, function(item, index) {
          return _c(
            "div",
            { key: `item-index-${index}` },
            [
              _c(
                "time-line-item",
                {
                  staticClass: "custom-time-line rounded",
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "icon",
                        fn: function() {
                          return [
                            _c(
                              "span",
                              {
                                staticClass:
                                  "fa-stack fa-1x color-gray-2 font-18 mr-3"
                              },
                              [
                                _c("em", {
                                  staticClass: "fas fa-circle fa-stack-2x"
                                }),
                                _c("em", {
                                  staticClass:
                                    "fas fa-comment fa-stack-1x fa-inverse"
                                })
                              ]
                            )
                          ]
                        },
                        proxy: true
                      },
                      {
                        key: "date",
                        fn: function() {
                          return [
                            _c("div", { staticClass: "date-container" }, [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "color-black font-16 font-weight-bold fulldate"
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(_vm._f("date")(item.date)) +
                                      " "
                                  )
                                ]
                              ),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "color-black font-12 font-weight-normal hour"
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(_vm._f("hour")(item.date)) +
                                      " "
                                  )
                                ]
                              )
                            ])
                          ]
                        },
                        proxy: true
                      }
                    ],
                    null,
                    true
                  )
                },
                [
                  _c("div", { staticClass: "row pb-4" }, [
                    _c("div", { staticClass: "col-12 ml-5 pt-3" }, [
                      _c(
                        "div",
                        {
                          staticClass: "color-gray-6 font-14 font-weight-normal"
                        },
                        [_vm._v(" Comentario: ")]
                      ),
                      _c(
                        "div",
                        {
                          staticClass:
                            "color-black font-16 font-weight-normal pt-2"
                        },
                        [_vm._v(" " + _vm._s(item.comment) + " ")]
                      )
                    ])
                  ])
                ]
              )
            ],
            1
          )
        }),
        0
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }